<template>
  <Header />
  <body class="bg-white">
    <slot />
  </body>
  <Footer />
</template>
